import { ActionCard } from '@pcln/cards'
import styled from 'styled-components'

export const StyledActionCard = styled(ActionCard)`
  height: 100%;
`
